import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhoneMedical2 = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.25 16.375V19.0975C13.2501 19.3966 13.1913 19.6928 13.0769 19.9692C12.9624 20.2456 12.7947 20.4967 12.5832 20.7082C12.3717 20.9197 12.1206 21.0874 11.8442 21.2019C11.5678 21.3163 11.2716 21.3751 10.9725 21.375H5.5275C5.22838 21.3751 4.93218 21.3163 4.65581 21.2019C4.37944 21.0874 4.12833 20.9197 3.91682 20.7082C3.70531 20.4967 3.53756 20.2456 3.42314 19.9692C3.30873 19.6928 3.24989 19.3966 3.25 19.0975V6.1525C3.24989 5.85338 3.30873 5.55718 3.42314 5.28081C3.53756 5.00444 3.70531 4.75333 3.91682 4.54182C4.12833 4.33031 4.37944 4.16256 4.65581 4.04814C4.93218 3.93373 5.22838 3.87489 5.5275 3.875H9.5"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.25 17.6408H13.25"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.75 7C20.75 6.83424 20.6842 6.67527 20.5669 6.55806C20.4497 6.44085 20.2908 6.375 20.125 6.375H17V3.25C17 3.08424 16.9342 2.92527 16.8169 2.80806C16.6997 2.69085 16.5408 2.625 16.375 2.625H13.875C13.7092 2.625 13.5503 2.69085 13.4331 2.80806C13.3158 2.92527 13.25 3.08424 13.25 3.25V6.375H10.125C9.95924 6.375 9.80027 6.44085 9.68306 6.55806C9.56585 6.67527 9.5 6.83424 9.5 7V9.5C9.5 9.66576 9.56585 9.82473 9.68306 9.94194C9.80027 10.0592 9.95924 10.125 10.125 10.125H13.25V13.25C13.25 13.4158 13.3158 13.5747 13.4331 13.6919C13.5503 13.8092 13.7092 13.875 13.875 13.875H16.375C16.5408 13.875 16.6997 13.8092 16.8169 13.6919C16.9342 13.5747 17 13.4158 17 13.25V10.125H20.125C20.2908 10.125 20.4497 10.0592 20.5669 9.94194C20.6842 9.82473 20.75 9.66576 20.75 9.5V7Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhoneMedical2.displayName = 'SvgPhoneMedical2';
export default SvgPhoneMedical2;
